import React from 'react'
import "../../../Assets/css/oris.css"
import { isMobile } from 'react-device-detect'
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import DeskBanner from "../../../Assets/images/watches/oris/oris-desk.png"
import MobileBanner from "../../../Assets/images/watches/oris/oris-mobile.png"

import { Link } from "react-router-dom";
import img1 from '../../../Assets/images/watches/oris/item1.png'
import img2 from '../../../Assets/images/watches/oris/item2.png'
import img3 from '../../../Assets/images/watches/oris/item3.png'
import img4 from '../../../Assets/images/watches/oris/item4.png'


import OricSecBanner from "../../../Assets/images/watches/oris/oris-second.png"

import ImgBox1 from "../../../Assets/images/watches/oris/box1.png"
import ImgBox2 from "../../../Assets/images/watches/oris/box2.png"

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Oris() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        accessibility: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
        ]
    };
    return (
        <>
            <section className='oris_banner'>
                <div className="oris-watches-banner-section"
                    style={{
                        backgroundImage: `url(${isMobile ? MobileBanner : DeskBanner})`,
                    }}
                >
                    <div className="oris-watches-banner-overlay">
                        <Container>
                            <Row>
                                <Col lg={12} xs={12} className="m-auto">
                                    <div className="text-center oris-watches-banner-content">
                                        <h2 className="oris-watches-banner-title">Discover Oris  Swiss Made Excellence</h2>
                                        <p className="oris-watches-banner-subtitle">
                                            Innovative. Independent. Timeless.
                                        </p>
                                        <Button
                                            as={Link}
                                            to="/watches-list/ORIS" variant="light" className="oris-watches-banner-btn">
                                            Shop Now
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </div>
            </section>

            <section className='novelties_section_oris'>

                <Container className="watches_container_oris">
                    <h2 className="title_nov">Our Collection</h2>

                    <Row className="g-4 justify-content-center">
                        <Col xs={12}>
                            {isMobile ? (
                                <Slider {...settings}>
                                    {[
                                        { name: "Aquis", ImgUrl: img1, urlLink: "/watches-list/ORIS" },
                                        { name: "divers", ImgUrl: img2, urlLink: "/watches-list/ORIS" },
                                        { name: "Propilot x", ImgUrl: img3, urlLink: "/watches-list/ORIS" },
                                        { name: "big crown", ImgUrl: img4, urlLink: "/watches-list/ORIS" },
                                    ].map((item, index) => (
                                        <div key={index} className="oris_product_box">
                                            <Link to={item.name}>  <img src={item.ImgUrl} alt={item.name} /> </Link>
                                            <div className='oris_product_title'>  <Link to={item.name}> {item.name} </Link> </div>
                                        </div>
                                    ))}
                                </Slider>
                            ) :
                                (
                                    <Row className="g-4 justify-content-center">
                                        {[
                                            { name: "Aquis", ImgUrl: img1, urlLink: "/watches-list/ORIS" },
                                            { name: "divers", ImgUrl: img2, urlLink: "/watches-list/ORIS" },
                                            { name: "Propilot x", ImgUrl: img3, urlLink: "/watches-list/ORIS" },
                                            { name: "big crown", ImgUrl: img4, urlLink: "/watches-list/ORIS" },
                                        ].map((item, index) => (
                                            <Col key={index} xs={12} sm={4} md={4} lg={3}>
                                                <div key={index} className="oris_product_box">
                                                    <Link to={item.urlLink}>  <img src={item.ImgUrl} alt={item.name} /> </Link>
                                                    <div className='oris_product_title'>  <Link to={item.urlLink}> {item.name} </Link> </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                )

                            }

                        </Col>
                    </Row>
                </Container >
            </section >

            <section className='hamilt_end_banner'>
                <div className='hamilt_end_banner_img'>
                    <Link to="/watches-list/ORIS">    <img src={OricSecBanner} alt="oris-banner" /> </Link>
                </div>
            </section>


            <section className='oris_img_box_section'>

                <Container className="watches_container_oris_box">
                    <Row>
                        <Col lg={6} sm={6} xs={12}>
                            <div className='oris_img_box'>
                               <Link to="/watches-list/ORIS">  <img src={ImgBox1} alt="img1" /> </Link>
                            </div>
                        </Col>
                        <Col lg={6} sm={6} xs={12}>
                            <div className='oris_img_box'>
                               <Link to="/watches-list/ORIS"> <img src={ImgBox2} alt="img1" /> </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

export default Oris